(() => {
  const SELECTOR_GALLERY = "media-gallery";
  const SELECTOR_ACTIVE = 'slideshow-slide[aria-hidden="false"]';

  const getActiveSlide = (gallery) =>
    gallery.querySelector(SELECTOR_ACTIVE) ||
    gallery.querySelector("slideshow-slide");

  const syncGlowFromGallery = (gallery) => {
    const slide = getActiveSlide(gallery);
    if (!slide) return;

    // slide now correctly exposes the vars (your latest test proves it)
    const cs = getComputedStyle(slide);

    const img = cs.getPropertyValue("--reflection-image").trim();
    const blur = cs.getPropertyValue("--reflection-blur").trim();
    const op = cs.getPropertyValue("--reflection-opacity").trim();
    const sat = cs.getPropertyValue("--reflection-saturation").trim();

    const root = document.documentElement;
    const body = document.body;

    if (!img || img === "none") {
      body.classList.remove("reflection-glow-on");
      root.style.removeProperty("--reflection-image");
      return;
    }

    root.style.setProperty("--reflection-image", img);
    if (blur) root.style.setProperty("--reflection-blur", blur);
    if (op) root.style.setProperty("--reflection-opacity", op);
    if (sat) root.style.setProperty("--reflection-saturation", sat);

    body.classList.add("reflection-glow-on");
  };

  const observeGallery = (gallery) => {
    let raf = 0;
    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        syncGlowFromGallery(gallery);
      });
    };

    // run once after paint
    requestAnimationFrame(schedule);

    // observe aria-hidden switches
    const slidesRoot = gallery.querySelector("slideshow-slides") || gallery;

    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "attributes" && m.attributeName === "aria-hidden") {
          schedule();
          return;
        }
      }
    });

    mo.observe(slidesRoot, { subtree: true, attributes: true, attributeFilter: ["aria-hidden"] });

    // extra triggers
    gallery.addEventListener("pointerup", schedule, { passive: true });
    gallery.addEventListener("keyup", schedule, { passive: true });
  };

  const boot = () => {
    document.querySelectorAll(SELECTOR_GALLERY).forEach(observeGallery);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
